<template lang="html">
<div>
  <BaseError v-bind:errorMsg="errorMsg">
  </BaseError>
  <BaseMovementEvent
    v-bind:event="event"
    v-bind:eventType="eventType"
    v-bind:debug="debug"
    v-on:deviceorientation="throttledOnNewSensorData">
    <template
      v-slot:sensorOutput>
      <li> absolute: <code>{{ sensorData.absolute }}</code></li>
      <li> alpha: <code>{{ sensorData.alpha }}</code></li>
      <li> beta: <code>{{ sensorData.beta }}</code></li>
      <li> gamma: <code>{{ sensorData.gamma }}</code></li>
    </template>
  </BaseMovementEvent>
</div>
</template>

<script>
import BaseError from './BaseError'
import BaseMovementEvent from './BaseMovementEvent.vue'
import { ORIENTATION } from '@/utils/mmccMessageTypes'
import throttle from 'lodash.throttle'

export default {
  components: {
    BaseMovementEvent,
    BaseError
  },
  props: {
    minInterval: {
      type: Number,
      default: 50 // milliseconds
    }
  },
  data () {
    return {
      event: DeviceOrientationEvent,
      eventType: 'deviceorientation',
      debug: true,
      sensorData: {},
      errorMsg: ''
    }
  },
  created () {
    this.throttledOnNewSensorData = throttle(
      this.onNewSensorData, this.minInterval)
  },
  methods: {
    onNewSensorData (event) {
      // console.log(event);
      if (event.absolute) {
        this.sensorData.absolute = event.absolute
      }
      if (event.alpha) {
        this.sensorData.alpha = event.alpha.toFixed(1)
      }
      if (event.beta) {
        this.sensorData.beta = event.beta.toFixed(1)
      }
      if (event.gamma) {
        this.sensorData.gamma = event.gamma.toFixed(1)
      }

      if (Object.keys(this.sensorData).length === 0) {
        this.errorMsg = `Your device does not seem to have motion
sensors`
      } else {
        this.$emit('deviceorientation', {
          type: ORIENTATION,
          sensorData: {
            absolute: event.absolute,

            // rotation
            // 0/360 = north
            // 270 = east
            // 180 = south
            // 90 = west
            alpha: event.alpha,

            // up and down
            // -180 = flat upside-down
            // -90 = straight upside-down
            // 0 = flat
            // 90 = straight up
            // 180 = upside-down
            beta: event.beta,

            // left and right
            // -90 = left edge
            // 0 = flat
            // 90 = right edge
            gamma: event.gamma
          }
        })
      }
    }
  }
}
</script>
